<template>
    <div>
        <div class="student-account-information-title-text">{{dialogTitle}}</div>
        <el-form label-position="top" ref="formLabelAlignRef" :hide-required-asterisk="true" :rules="rulesFormLabelAlign" label-width="80px" :model="formLabelAlign">
          <el-form-item prop="gradeId">
            <div slot="label">
              <div class="label-text">
                年級
                <span class="star-mark">*</span>
              </div>
            </div>
            <el-select v-model="formLabelAlign.gradeId" placeholder="請選擇年級">
              <el-option
                v-for="(item, index) in grades"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="startDate">
            <div slot="label">
              <div class="label-text">
                開始訂閱日期
                <span class="star-mark">*</span>
              </div>
            </div>
            <el-date-picker
              v-model="formLabelAlign.startDate"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="請選擇日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item prop="type">
            <div slot="label">
              <div class="label-text">
                付款類型
                <span class="star-mark">*</span>
              </div>
            </div>
            <el-select v-model="formLabelAlign.type" placeholder="請選擇付款類型">
              <el-option
                v-for="item in paymentType.filter((v)=>{
                  return v.value !== 0 && v.value !== 3
                })"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
    </div>
</template>

<script>
    export default {
        props:{
            grades:{
                type:Array,
                default:()=>[]
            },
            dialogTitle:{
                type:String,
                default:''
            },
            formLabelAlign:{
                type:Object,
                default:()=>{}
            }
        },
        data() {
            return {
                rulesFormLabelAlign:{
                    gradeId:[{ required: true, message: "請選擇年級", trigger: "change" }],
                    startDate:[{ required: true, message: "請選擇開始訂閱日期", trigger: "change" }],
                    type:[{ required: true, message: "請選擇付款類型", trigger: "change" }],
                },
            }
        },

    }
</script>

<style lang="scss" scoped>
.student-account-information-title-text {
  font-size: 22px;
  color: #b62d2e;
  font-weight: bold;
}
</style>